import React from 'react'
import hoc from '@hoc'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import { SaveAlt } from '@material-ui/icons'
import { Grid, Divider, Button, FormControlLabel, Checkbox, FormLabel } from '@material-ui/core'
import { GameMultiSelect, DatetimeSelect, AgentsMulitSelect } from '@select'
import { API } from '@const'
import * as utils from '@utils'
import moment from 'moment'
import { Spin, Icon } from 'antd';
import ExcelJs from "exceljs/dist/exceljs";


class OnlinePlayerPage extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key) => {
            return utils.t(key, 'OnlinePlayerPage')
        }
        this.state = {
            listData: [],
            excelHeaders: [
                { label: this.t('date'), key: "date", width: 15 },
                { label: this.t('recordTime'), key: "time", width: 10 },
                { label: this.t('currency'), key: "currencyName", width: 25 },
                { label: this.t('rootRole'), key: "agent", width: 15 },
                { label: this.t('numberOfPeople'), key: "count", width: 10 }
            ],
            loading: false,
            isRealTimeCaculation: false,
            pfSubPfListDisabled: false,
            pfId: '',
            agentListId: [],
        }
    }

    queryData() {
        if (this.state.loading) { return }
        let valid = true
        const game_code = this.gameSelect.state.gameList
        if (moment(this.dateSelect.state.startDate).add(31, 'd').isBefore(this.dateSelect.state.endDate)) {
            utils.addToast(this.t('dateRangeError'), 'error')
            valid = false
        }
        if (!this.state.agentListId.length) {
            utils.addToast(this.t('selectAgent'), 'error')
            valid = false
        }
        if (game_code.length === 0) {
            utils.addToast(this.t('selectGame'), 'error')
            valid = false
        }
        if (valid === false) {
            return false
        }
        
        const start_date = utils.datetimeToUnix_startOf(this.dateSelect.state.startDate, 'minute')
        const end_date = utils.datetimeToUnix_startOf(this.dateSelect.state.endDate, 'minute')

        this.setState({
            loading: true
        })
        const queryParams = {
            pf_id: this.state.pfId,
            agent_list_id: this.state.agentListId,
            game_code,
            frequency: 10,
            start_date,
            end_date,
        }
        utils.apiRequest(
            'post',
            API.ONLINE_PLAYER_LIST,
            queryParams,
            (dataList) => {
                try {
                    const list = []
                    const currencyName = this.t('Platform.' + this.state.pfId) + ` (${this.t('Currency.' + utils.getPfCurrency(this.state.pfId))})`
                    /** 產生資訊 */
                    Object.entries(dataList).forEach(([agentName, timeList]) => {
                        Object.entries(timeList).forEach(([dateTime, count]) => {

                            list.push({
                                date: moment(dateTime).format('YYYY-MM-DD'),
                                time: moment(dateTime).format('HH:mm'),
                                currencyName,
                                agent: agentName,
                                count: utils.currencyFormatter(count, 0)
                            })
                        })

                    })
                    if (!list.length) {
                        utils.addToast(utils.getCodeMsg('11002'), 'error')
                        return
                    }
                    this.handleDataToExportExcel(list)
                } catch(error) {
                    console.log(error)
                }  
                this.setState({
                    loading: false
                });
            },
            (_err) => {
                console.log(_err)
                this.setState({
                    loading: false
                })
            },
            true
        )
    }
    sortPlatform(platformList, key) {
        platformList.sort((a, b)=>{
            const a_value = a[key] || a
            const b_value = b[key] || b
            return a_value.length > b_value.length ? -1 : 1
        })
        utils.sortPlatform(platformList, key)
    }

    handleDataToExportExcel(list) {
        /** 將資料依照順序轉成陣列化 */
        const excelBody = []
        list.forEach((item) => {
            const data = []
            this.state.excelHeaders.forEach((head)=>{
                data.push(item[head.key])
            })
            excelBody.push(data)
        })
        
        const workbook = new ExcelJs.Workbook();
        const sheet = workbook.addWorksheet(this.t('Title'));

        sheet.addTable({
            name: this.t('Title'), 
            ref: 'A1',
            columns: this.state.excelHeaders.map(item => {return {'name': item.label}}),
            rows: excelBody
        })

        this.state.excelHeaders.forEach((column, index)=>{
            sheet.getColumn(index+1).width = column.width
        });
    
        workbook.xlsx.writeBuffer().then((content) => {
            const link = document.createElement("a");
            const blobData = new Blob([content], {
                type: "application/vnd.ms-excel;charset=utf-8;"
            });
            link.download = `${this.t('Title')}.xlsx`;
            link.href = URL.createObjectURL(blobData);
            link.click();
        })
    }

    render() {
        const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;
        return (
            <Grid container spacing={2} className={this.props.classes.search}>
                <DatetimeSelect
                    onRef={(ref) => (this.dateSelect = ref)}
                />
                <GameMultiSelect
                    onRef={(ref) => (this.gameSelect = ref)}
                    options={{
                        hideAllGame: false,
                        defaultAll: true
                    }}
                    disabledList={[]}
                    classes={{formControl: this.props.classes.gameFormControl}}
                />
                <AgentsMulitSelect
                    classes={{
                        treeSelect: this.props.classes.treeSelect,
                        formControl: this.props.classes.formControl
                    }}
                    checkedValue={(key, value)=>{
                        this.setState({
                            [key]: value
                        })
                    }}
                />
                <Grid item className={clsx(this.props.classes.alignCenter)}>
                    <Button
                        variant="contained"
                        color="primary"
                        className={this.props.classes.button}
                        onClick={() => {
                            this.queryData()
                        }}>
                        {this.state.loading && <Spin indicator={antIcon} className={this.props.classes.loadingIcon} />}
                        {!this.state.loading && <SaveAlt className={this.props.classes.rightIcon} />}
                        {this.t('export')}
                    </Button>
                    <FormLabel className={clsx(this.props.classes.shrink, this.props.classes.labelMarginClear, this.props.classes.colorInitial)}>{this.t('recordPeriod')}</FormLabel>
                </Grid>
                {false && <Grid item className={clsx(this.props.classes.alignCenter, {[this.props.classes.hide] : !this.props.auth.isAdmin})}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={this.state.isRealTimeCaculation}
                                onChange={(event) => {
                                    this.setState({
                                        isRealTimeCaculation: event.target.checked,
                                    })
                                }}
                                name="checked"
                                color="primary"
                            />
                        }
                        label={this.t('isRealTimeCaculation')}
                        className={this.props.classes.labelMarginClear}
                    />
                </Grid>}
                <Grid item xs={12}>
                    <Divider />
                </Grid>
            </Grid>
        )
    }
}

const styles = (theme) => {
    return {
        button: {
            margin: theme.spacing(1),
        },
        rightIcon: {
            marginRight: theme.spacing(1),
        },
        hide: {
            display: 'none',
        },
        downLoadBtn: {
            opacity: 0,
            position: 'fixed',
            pointerEvent: 'none',
        },
        loadingIcon: {
            marginRight: theme.spacing(1),
            color: '#fff',
        },
        alignCenter: {
            display: 'inline-flex',
            alignItems: 'center',
        },
        labelMarginClear: {
            margin: 0,
        },
        search: {
            display: 'flex',
            '& label + .MuiInput-formControl': {
                marginTop: 22,
            }
        },
        formControl: {
            margin: theme.spacing(1),
            width: '180px',
        },
        treeSelect: {
            width: '100%',
        },
        colorInitial: {
            color: 'initial'
        },
        gameFormControl: {
            margin: theme.spacing(1),
            width: 'auto',
        }
    }
}

OnlinePlayerPage.propTypes = {
    classes: PropTypes.object.isRequired,
    auth: PropTypes.object,
    dataService: PropTypes.object,
}

export default hoc(styles)(OnlinePlayerPage)
